import {
    /* auth */
    FETCH_AUTH_RESOURCE_REQUEST,
    FETCH_AUTH_RESOURCE_SUCCESS,
    FETCH_AUTH_RESOURCE_FAILED,
    CREATE_MEMBER_AUTH_REQUEST,
    CREATE_MEMBER_AUTH_SUCCESS,
    CREATE_MEMBER_AUTH_FAILED,
    DELETE_MEMBER_AUTH_REQUEST,
    DELETE_MEMBER_AUTH_SUCCESS,
    DELETE_MEMBER_AUTH_FAILED,
    CREATE_MEMBER_AUTH_OTP_REQUEST,
    CREATE_MEMBER_AUTH_OTP_SUCCESS,
    CREATE_MEMBER_AUTH_OTP_FAILED,
    CREATE_MEMBER_AUTH_AGAIN_REQUEST,
    CREATE_MEMBER_AUTH_AGAIN_SUCCESS,
    CREATE_MEMBER_AUTH_AGAIN_FAILED,
    SAVE_AUTH_FROM,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    /* Board */
    FETCH_BOARD_DOCUMENTS_REQUEST,
    FETCH_BOARD_DOCUMENTS_SUCCESS,
    FETCH_BOARD_DOCUMENTS_FAILED,
    FETCH_BOARD_DOCUMENT_REQUEST,
    FETCH_BOARD_DOCUMENT_SUCCESS,
    FETCH_BOARD_DOCUMENT_FAILED,

    /* Profile */
    FETCH_LOG_HISTORY_REQUEST,
    FETCH_LOG_HISTORY_SUCCESS,
    FETCH_LOG_HISTORY_FAILED,
    FETCH_USER_INFO_REQUEST,
    FETCH_USER_INFO_SUCCESS,
    FETCH_USER_INFO_FAILED,
    FETCH_CHANGE_PASSWORD_REQUEST,
    FETCH_CHANGE_PASSWORD_SUCCESS,
    FETCH_CHANGE_PASSWORD_FAILED,
    FETCH_CHANGE_LATER_REQUEST,
    FETCH_CHANGE_LATER_SUCCESS,
    FETCH_CHANGE_LATER_FAILED,
    CREATE_OTP_REQUEST,
    CREATE_OTP_SUCCESS,
    CREATE_OTP_FAILED,
    DELETE_OTP_REQUEST,
    DELETE_OTP_SUCCESS,
    DELETE_OTP_FAILED,
    CREATE_AGREE_DOCUMENT_REQUEST,
    CREATE_AGREE_DOCUMENT_SUCCESS,
    CREATE_AGREE_DOCUMENT_FAILED,

    /* Document */
    FETCH_AGREE_VERSION_REQUEST,
    FETCH_AGREE_VERSION_SUCCESS,
    FETCH_AGREE_VERSION_FAILED,
    FETCH_AGREE_DOCUMENT_REQUEST,
    FETCH_AGREE_DOCUMENT_SUCCESS,
    FETCH_AGREE_DOCUMENT_FAILED,
    FETCH_PRIVACY_VERSION_REQUEST,
    FETCH_PRIVACY_VERSION_SUCCESS,
    FETCH_PRIVACY_VERSION_FAILED,
    FETCH_PRIVACY_DOCUMENT_REQUEST,
    FETCH_PRIVACY_DOCUMENT_SUCCESS,
    FETCH_PRIVACY_DOCUMENT_FAILED

} from './mutation-type'
import bus from '@/libs/bus'

export default {
    /*
        auth
    */
    [FETCH_AUTH_RESOURCE_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_AUTH_RESOURCE_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [FETCH_AUTH_RESOURCE_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
    },
    [CREATE_MEMBER_AUTH_REQUEST]: state => {
        state.status = 'loading'
    },
    [CREATE_MEMBER_AUTH_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [CREATE_MEMBER_AUTH_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
    },
    [DELETE_MEMBER_AUTH_REQUEST]: state => {
        state.status = 'loading'
    },
    [DELETE_MEMBER_AUTH_SUCCESS]: (state, data) => {
        localStorage.removeItem('x-auth-token')
        localStorage.removeItem('NAMESPACE')
        state.status = 'success'
    },
    [DELETE_MEMBER_AUTH_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [CREATE_MEMBER_AUTH_OTP_REQUEST]: state => {
        state.status = 'loading'
    },
    [CREATE_MEMBER_AUTH_OTP_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [CREATE_MEMBER_AUTH_OTP_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
    },
    [CREATE_MEMBER_AUTH_AGAIN_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [CREATE_MEMBER_AUTH_AGAIN_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [CREATE_MEMBER_AUTH_AGAIN_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [SAVE_AUTH_FROM]: (state, data) => {
        state.auth.from = data
    },
    [RESET_PASSWORD_REQUEST]: state => {
        state.status = 'loading'
    },
    [RESET_PASSWORD_SUCCESS]: (state, data) => {
        state.status = 'success'
        bus.$emit('request:success', { title: 'SUCCESS', content: data.status })
    },
    [RESET_PASSWORD_FAILED]: (state, error) => {
        state.status = 'error'
    },
    /*
        Board
    */
    [FETCH_BOARD_DOCUMENTS_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_BOARD_DOCUMENTS_SUCCESS]: (state, data) => {
        state.board.boardDocuments = data.data.documents
        state.status = 'success'
    },
    [FETCH_BOARD_DOCUMENTS_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_BOARD_DOCUMENT_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_BOARD_DOCUMENT_SUCCESS]: (state, data) => {
        state.board.boardDocument = data.data.document
        state.status = 'success'
    },
    [FETCH_BOARD_DOCUMENT_FAILED]: (state, data) => {
        state.status = 'error'
    },

    /* Profile  */
    [FETCH_LOG_HISTORY_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_LOG_HISTORY_SUCCESS]: (state, data) => {
        state.profile.logHistory = data.data
        state.status = 'success'
    },
    [FETCH_LOG_HISTORY_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_USER_INFO_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_USER_INFO_SUCCESS]: (state, data) => {
        state.profile.userInfo = data.data
        state.status = 'success'
    },
    [FETCH_USER_INFO_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_CHANGE_PASSWORD_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_CHANGE_PASSWORD_SUCCESS]: (state, data) => {
        state.profile.userInfo = data.data
        state.status = 'success'
    },
    [FETCH_CHANGE_PASSWORD_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_CHANGE_LATER_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_CHANGE_LATER_SUCCESS]: (state, data) => {
        // state.profile.userInfo = data.data
        state.status = 'success'
    },
    [FETCH_CHANGE_LATER_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [CREATE_OTP_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [CREATE_OTP_SUCCESS]: (state, data) => {
        state.status = 'success'
    },
    [CREATE_OTP_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [DELETE_OTP_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [DELETE_OTP_SUCCESS]: (state, data) => {
        state.status = 'success'
    },
    [DELETE_OTP_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [CREATE_AGREE_DOCUMENT_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [CREATE_AGREE_DOCUMENT_SUCCESS]: (state, data) => {
        state.status = 'success'
    },
    [CREATE_AGREE_DOCUMENT_FAILED]: (state, data) => {
        state.status = 'error'
    },

    /* document */
    [FETCH_AGREE_VERSION_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_AGREE_VERSION_SUCCESS]: (state, data) => {
        state.status = 'success'
        state.document.agreementVersion = data
    },
    [FETCH_AGREE_VERSION_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_AGREE_DOCUMENT_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_AGREE_DOCUMENT_SUCCESS]: (state, data) => {
        state.status = 'success'
        state.document.agreementDocument = data
    },
    [FETCH_AGREE_DOCUMENT_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_PRIVACY_VERSION_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_PRIVACY_VERSION_SUCCESS]: (state, data) => {
        state.status = 'success'
        state.document.privacyVersion = data
    },
    [FETCH_PRIVACY_VERSION_FAILED]: (state, data) => {
        state.status = 'error'
    },
    [FETCH_PRIVACY_DOCUMENT_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_PRIVACY_DOCUMENT_SUCCESS]: (state, data) => {
        state.status = 'success'
        state.document.privacyDocument = data
    },
    [FETCH_PRIVACY_DOCUMENT_FAILED]: (state, data) => {
        state.status = 'error'
    }
}

const storeUserAuthInfo = (state, data) => {
    localStorage.setItem('x-auth-token', data.token)
    state.auth.prerequisites = data.prerequisites || []
    state.auth.needPrerequisite = data.needPrerequisite
    state.auth.userInfo = data.userInfo
    state.auth.authUserResource = data.userResource
    if (!data.needPrerequisite || (data.prerequisites && !data.prerequisites.includes('tc'))) {
        state.auth.serviceGroups = data.userResource?.serviceGroups
    }
}
